export default __webpack_public_path__ + "static/media/bit.c7e23d9d.svg";